import { headerNav } from './components/header-nav';
import { mobileNav } from './components/mobile-nav';
import { formValidation } from './components/form-validation';
import { accordion } from './components/accordion';
import { modals } from './components/modals';
import { csrfToken } from './components/csrf-token';
import { animations } from './components/animations';
import SmoothScroll from 'smooth-scroll';
//import { acsbTrigger } from './components/acsb'
import { lazyBg } from './components/lazyBg'
import { loadScripts } from './utility/lazyScripts'
import { navigation } from './components/navigation'
import { translation } from './components/translation'
import { jobSearch } from './components/jobSearch'
import { turboInsights } from "./components/turboInsights";

formValidation();
csrfToken();
headerNav();
mobileNav();
accordion();
modals();
animations();
//acsbTrigger();
lazyBg();
navigation();
translation();
jobSearch();

new SmoothScroll('.scroll');

loadScripts();
window.turboInsights = turboInsights;
